import Vue from 'vue';
import App from './App.vue';

const app = new Vue({
  el: '#app',
  render: h => h(App),
});

window.app = app;



// WEBPACK FOOTER //
// ./src/ngopartnership/app.js